import { concat } from '../../helpers/common'

const MODULE_NAME = 'RIGHTS/'

// PLOP_APPEND_PATTERN_ANCHOR_ACTION
export const GET_RIGHTS = concat(MODULE_NAME, 'GET_RIGHTS')
export const GET_RIGHTS_SUCCESS = concat(MODULE_NAME, 'GET_RIGHTS_SUCCESS')
export const GET_RIGHTS_FAILURE = concat(MODULE_NAME, 'GET_RIGHTS_FAILURE')
export const CLEAR_RIGHTS = concat(MODULE_NAME, 'CLEAR_RIGHTS')

export const GET_RIGHT = concat(MODULE_NAME, 'GET_RIGHT')
export const GET_RIGHT_SUCCESS = concat(MODULE_NAME, 'GET_RIGHT_SUCCESS')
export const GET_RIGHT_FAILURE = concat(MODULE_NAME, 'GET_RIGHT_FAILURE')
export const CLEAR_RIGHT = concat(MODULE_NAME, 'CLEAR_RIGHT')

export const CREATE_RIGHT = concat(MODULE_NAME, 'CREATE_RIGHT')
export const CREATE_RIGHT_SUCCESS = concat(MODULE_NAME, 'CREATE_RIGHT_SUCCESS')
export const CREATE_RIGHT_FAILURE = concat(MODULE_NAME, 'CREATE_RIGHT_FAILURE')
export const CLEAR_CREATE_RIGHT = concat(MODULE_NAME, 'CLEAR_CREATE_RIGHT')

export const UPDATE_RIGHT = concat(MODULE_NAME, 'UPDATE_RIGHT')
export const UPDATE_RIGHT_SUCCESS = concat(MODULE_NAME, 'UPDATE_RIGHT_SUCCESS')
export const UPDATE_RIGHT_FAILURE = concat(MODULE_NAME, 'UPDATE_RIGHT_FAILURE')
export const CLEAR_UPDATE_RIGHT = concat(MODULE_NAME, 'CLEAR_UPDATE_RIGHT')

export const DELETE_RIGHT = concat(MODULE_NAME, 'DELETE_RIGHT')
export const DELETE_RIGHT_SUCCESS = concat(MODULE_NAME, 'DELETE_RIGHT_SUCCESS')
export const DELETE_RIGHT_FAILURE = concat(MODULE_NAME, 'DELETE_RIGHT_FAILURE')
export const CLEAR_DELETE_RIGHT = concat(MODULE_NAME, 'CLEAR_DELETE_RIGHT')

export const GET_RIGHT_SUGGESTED_CHANGES = concat(MODULE_NAME, 'GET_RIGHT_SUGGESTED_CHANGES')
export const GET_RIGHT_SUGGESTED_CHANGES_SUCCESS = concat(MODULE_NAME, 'GET_RIGHT_SUGGESTED_CHANGES_SUCCESS')
export const GET_RIGHT_SUGGESTED_CHANGES_FAILURE = concat(MODULE_NAME, 'GET_RIGHT_SUGGESTED_CHANGES_FAILURE')
export const CLEAR_RIGHT_SUGGESTED_CHANGES = concat(MODULE_NAME, 'CLEAR_RIGHT_SUGGESTED_CHANGES')

export const APPLY_RIGHT_SUGGESTED_CHANGES = concat(MODULE_NAME, 'APPLY_RIGHT_SUGGESTED_CHANGES')
export const APPLY_RIGHT_SUGGESTED_CHANGES_SUCCESS = concat(MODULE_NAME, 'APPLY_RIGHT_SUGGESTED_CHANGES_SUCCESS')
export const APPLY_RIGHT_SUGGESTED_CHANGES_FAILURE = concat(MODULE_NAME, 'APPLY_RIGHT_SUGGESTED_CHANGES_FAILURE')
export const CLEAR_APPLY_RIGHT_SUGGESTED_CHANGES = concat(MODULE_NAME, 'CLEAR_APPLY_RIGHT_SUGGESTED_CHANGES')

export const GET_PARTNERBRAIN_HISTORY = concat(MODULE_NAME, 'GET_PARTNERBRAIN_HISTORY')
export const GET_PARTNERBRAIN_HISTORY_SUCCESS = concat(MODULE_NAME, 'GET_PARTNERBRAIN_HISTORY_SUCCESS')
export const GET_PARTNERBRAIN_HISTORY_FAILURE = concat(MODULE_NAME, 'GET_PARTNERBRAIN_HISTORY_FAILURE')
export const CLEAR_PARTNERBRAIN_HISTORY = concat(MODULE_NAME, 'CLEAR_PARTNERBRAIN_HISTORY')

export const GET_RIGHT_SOCIAL_POSTS = concat(MODULE_NAME, 'GET_RIGHT_SOCIAL_POSTS')
export const GET_RIGHT_SOCIAL_POSTS_SUCCESS = concat(MODULE_NAME, 'GET_RIGHT_SOCIAL_POSTS_SUCCESS')
export const GET_RIGHT_SOCIAL_POSTS_FAILURE = concat(MODULE_NAME, 'GET_RIGHT_SOCIAL_POSTS_FAILURE')
export const CLEAR_RIGHT_SOCIAL_POSTS = concat(MODULE_NAME, 'CLEAR_RIGHT_SOCIAL_POSTS')

export const SET_RIGHT_UPLOAD_AD_DATA = concat(MODULE_NAME, 'SET_RIGHT_UPLOAD_AD_DATA')
export const CLEAR_RIGHT_UPLOAD_AD_DATA = concat(MODULE_NAME, 'CLEAR_RIGHT_UPLOAD_AD_DATA')

// PLOP_APPEND_PATTERN_ANCHOR_ACTION_CREATOR

// get rights
export function getRights(params) {
  return { type: GET_RIGHTS, params }
}

export function getRightsSuccess(rightsData) {
  return { type: GET_RIGHTS_SUCCESS, rightsData }
}

export function getRightsFailure(error) {
  return { type: GET_RIGHTS_FAILURE, error }
}

export function clearRights() {
  return { type: CLEAR_RIGHTS }
}

// get right
export function getRight(
  id,
  getOptions = {
    isAsyncMode: false
  }
) {
  return { type: GET_RIGHT, id, getOptions }
}

export function getRightSuccess(rightData) {
  return { type: GET_RIGHT_SUCCESS, rightData }
}

export function getRightFailure(error) {
  return { type: GET_RIGHT_FAILURE, error }
}

export function clearRight() {
  return { type: CLEAR_RIGHT }
}

// create right
export function createRight(rightData) {
  return { type: CREATE_RIGHT, rightData }
}

export function createRightSuccess(rightData) {
  return { type: CREATE_RIGHT_SUCCESS, rightData }
}

export function createRightFailure(error) {
  return { type: CREATE_RIGHT_FAILURE, error }
}

export function clearCreateRight() {
  return { type: CLEAR_CREATE_RIGHT }
}

// update right
export function updateRight(id, rightData, method) {
  return { type: UPDATE_RIGHT, id, rightData, method }
}

export function updateRightSuccess(rightData) {
  return { type: UPDATE_RIGHT_SUCCESS, rightData }
}

export function updateRightFailure(error) {
  return { type: UPDATE_RIGHT_FAILURE, error }
}

export function clearUpdateRight() {
  return { type: CLEAR_UPDATE_RIGHT }
}

// delete right
export function deleteRight(id) {
  return { type: DELETE_RIGHT, id }
}

export function deleteRightSuccess(id) {
  return { type: DELETE_RIGHT_SUCCESS, id }
}

export function deleteRightFailure(error) {
  return { type: DELETE_RIGHT_FAILURE, error }
}

export function clearDeleteRight() {
  return { type: CLEAR_DELETE_RIGHT }
}

// Get right suggested changes
export function getRightSuggestedChanges(id) {
  return { type: GET_RIGHT_SUGGESTED_CHANGES, id }
}

export function getRightSuggestedChangesSuccess(data) {
  return { type: GET_RIGHT_SUGGESTED_CHANGES_SUCCESS, data }
}

export function getRightSuggestedChangesFailure(error) {
  return { type: GET_RIGHT_SUGGESTED_CHANGES_FAILURE, error }
}

export function clearRightSuggestedChanges() {
  return { type: CLEAR_RIGHT_SUGGESTED_CHANGES }
}

// Apply right suggested changes
export function applyRightSuggestedChanges(id) {
  return { type: APPLY_RIGHT_SUGGESTED_CHANGES, id }
}

export function applyRightSuggestedChangesSuccess(data) {
  return { type: APPLY_RIGHT_SUGGESTED_CHANGES_SUCCESS, data }
}

export function applyRightSuggestedChangesFailure(error) {
  return { type: APPLY_RIGHT_SUGGESTED_CHANGES_FAILURE, error }
}

export function clearApplyRightSuggestedChanges() {
  return { type: CLEAR_APPLY_RIGHT_SUGGESTED_CHANGES }
}

// Get partnerbrain history
export function getPartnerbrainHistory(params) {
  return { type: GET_PARTNERBRAIN_HISTORY, params }
}

export function getPartnerbrainHistorySuccess(data) {
  return { type: GET_PARTNERBRAIN_HISTORY_SUCCESS, data }
}

export function getPartnerbrainHistoryFailure(error) {
  return { type: GET_PARTNERBRAIN_HISTORY_FAILURE, error }
}

export function clearPartnerbrainHistory() {
  return { type: CLEAR_PARTNERBRAIN_HISTORY }
}

// Get right social posts
export function getRightSocialPosts(params) {
  return { type: GET_RIGHT_SOCIAL_POSTS, params }
}

export function getRightSocialPostsSuccess(data) {
  return { type: GET_RIGHT_SOCIAL_POSTS_SUCCESS, data }
}

export function getRightSocialPostsFailure(error) {
  return { type: GET_RIGHT_SOCIAL_POSTS_FAILURE, error }
}

export function clearRightSocialPosts() {
  return { type: CLEAR_RIGHT_SOCIAL_POSTS }
}

// right upload ad
export function setRightUploadAdData(data, platform) {
  return { type: SET_RIGHT_UPLOAD_AD_DATA, data, platform }
}

export function clearRightUploadAdData(platform) {
  return { type: CLEAR_RIGHT_UPLOAD_AD_DATA, platform }
}
